var map = {
	"./LogoSancoInternet.svg": 362,
	"./Trash.svg": 961,
	"./TryggEhandel.svg": 962,
	"./arrow.svg": 963,
	"./assortment_checkmark.svg": 964,
	"./assortment_store.svg": 965,
	"./assortment_truck.svg": 966,
	"./b_house.svg": 456,
	"./b_shelf.svg": 967,
	"./cart-black.svg": 358,
	"./cart.svg": 968,
	"./cart_rounded.svg": 969,
	"./chat-white.svg": 970,
	"./chat.svg": 971,
	"./checkbox-large-off.svg": 972,
	"./checkbox-large-on.svg": 973,
	"./checkbox-small-off.svg": 974,
	"./checkbox-small-on.svg": 975,
	"./chef_hat.svg": 976,
	"./clock.svg": 205,
	"./close.svg": 977,
	"./comment.svg": 978,
	"./cookiebanner.svg": 979,
	"./facebook.svg": 363,
	"./faq.svg": 364,
	"./favorite-filled.svg": 980,
	"./favorite-outlined.svg": 981,
	"./fitting-recipes.svg": 982,
	"./highlight-icon.svg": 983,
	"./house_black.svg": 984,
	"./house_black_active.svg": 985,
	"./housing.svg": 986,
	"./image-fallback.svg": 360,
	"./info.svg": 987,
	"./infoSmall.svg": 988,
	"./info_icon.svg": 989,
	"./instagram.svg": 365,
	"./mail.svg": 295,
	"./matkasse-fallback.svg": 990,
	"./nav_house.svg": 991,
	"./nav_house_active.svg": 992,
	"./pen.svg": 993,
	"./phone.svg": 294,
	"./pricesplash-klipp.svg": 994,
	"./pricesplash-prio.svg": 995,
	"./pricesplash.svg": 996,
	"./print.svg": 997,
	"./prio_badge.svg": 263,
	"./produkt-fallback.svg": 96,
	"./radiobutton-off.svg": 998,
	"./radiobutton-on.svg": 999,
	"./recept-fallback.svg": 359,
	"./remove-white.svg": 1000,
	"./remove.svg": 1001,
	"./replace.svg": 1002,
	"./round-spinner.svg": 256,
	"./search.svg": 455,
	"./share.svg": 1003,
	"./success.svg": 444,
	"./switch.svg": 1004,
	"./tips-fran-oss.svg": 361,
	"./trashcan_dark.svg": 1005,
	"./truck_black.svg": 1006,
	"./truck_blue.svg": 1007,
	"./truck_white.svg": 1008,
	"./twitter.svg": 366,
	"./varor.svg": 264,
	"./veg.svg": 450,
	"./vegan.svg": 451,
	"./warning.svg": 314,
	"./youtube.svg": 367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 960;